export default __webpack_public_path__ + "images/20976d03874c5e68ceea0ecd29f425ef-generic_1.jpg";